/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Role_PlaceholderInputs */

const en_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const de_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Senior Frontend Engineer`)
};

const fr_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Senior Frontend Engineer`)
};

const es_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Senior Frontend Engineer`)
};

const it_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Senior Frontend Engineer`)
};

const nl_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Senior Frontend Engineer`)
};

const pl_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Senior Frontend Engineer`)
};

const fi_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. Senior Frontend Engineer`)
};

const da_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. Senior Frontend Engineer`)
};

const sv_salary_negotiate_role_placeholder = /** @type {(inputs: Salary_Negotiate_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. Senior Frontend Engineer`)
};

/**
* | output |
* | --- |
* | "e.g. Senior Frontend Engineer" |
*
* @param {Salary_Negotiate_Role_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_role_placeholder = /** @type {((inputs?: Salary_Negotiate_Role_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Role_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_role_placeholder(inputs)
	if (locale === "fr") return fr_salary_negotiate_role_placeholder(inputs)
	if (locale === "es") return es_salary_negotiate_role_placeholder(inputs)
	if (locale === "it") return it_salary_negotiate_role_placeholder(inputs)
	if (locale === "nl") return nl_salary_negotiate_role_placeholder(inputs)
	if (locale === "pl") return pl_salary_negotiate_role_placeholder(inputs)
	if (locale === "fi") return fi_salary_negotiate_role_placeholder(inputs)
	if (locale === "da") return da_salary_negotiate_role_placeholder(inputs)
	if (locale === "sv") return sv_salary_negotiate_role_placeholder(inputs)
	return en_salary_negotiate_role_placeholder(inputs)
});